var _defs, _rect, _ellipse, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultVehicle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1f2a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c101a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "50%",
    cy: "40%",
    r: "45%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4f9cf9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#14213b",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "carBody",
    x1: "0%",
    y1: "30%",
    x2: "100%",
    y2: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9ec9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4b6cb7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "window",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#dfe9ff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8aa5d6",
    stopOpacity: 0.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#bgGradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 560,
    rx: 520,
    ry: 220,
    fill: "url(#glow)",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150 260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870 200c40 0 80 30 90 70l20 90c4 18-9 34-28 34h-58c-28 63-98 110-184 110H330c-86 0-156-47-184-110h-76c-19 0-32-16-28-34l22-104c8-37 36-71 72-84 82-30 170-44 260-44h214c90 0 178 14 260 44z",
    fill: "url(#carBody)",
    stroke: "#c0d8ff",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 70h320c74 0 145 29 198 81l48 48H170l48-48c53-52 124-81 198-81z",
    fill: "url(#window)",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 430c0-72-58-130-130-130s-130 58-130 130 58 130 130 130 130-58 130-130zm-70 0c0 33-27 60-60 60s-60-27-60-60 27-60 60-60 60 27 60 60z",
    fill: "#1b2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070 430c0-72-58-130-130-130s-130 58-130 130 58 130 130 130 130-58 130-130zm-70 0c0 33-27 60-60 60s-60-27-60-60 27-60 60-60 60 27 60 60z",
    fill: "#1b2435"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 430,
    r: 36,
    fill: "#9ec9ff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 940,
    cy: 430,
    r: 36,
    fill: "#9ec9ff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 260h880c24 0 42 22 36 46l-10 42c-3 12-14 20-26 20H70c-12 0-23-8-26-20l-10-42c-6-24 12-46 36-46z",
    fill: "#121a29",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 120h420c10 0 18 8 18 18v70c0 10-8 18-18 18H330c-10 0-18-8-18-18v-70c0-10 8-18 18-18z",
    fill: "#1c2a3f",
    opacity: 0.7
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 170,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 64,
    fill: "#d7e4ff",
    opacity: 0.85
  }, "Vehicle Preview")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 230,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 28,
    fill: "#96b2e8",
    opacity: 0.75
  }, "Image unavailable \u2014 showing placeholder")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultVehicle);
export default __webpack_public_path__ + "static/media/default-vehicle.88217d83d358d4f5ddd5d81a30f4fdf4.svg";
export { ForwardRef as ReactComponent };